import React, { Fragment, useMemo } from 'react'
import { MyIcon } from '~/components/ui/MyIcon'
import { StyledRankContent } from './RankStyle'
import { MyEmpty } from '~/components/ui/MyEmpty'
import { MyImage } from '~/components/ui/MyImage'
import { CreatorAvatar } from '~/components/business/CreatorAvatar'
import { useRouter } from 'next/router'
import { FenToYuan, digitalUnit } from '~/utils'
import { MyRare } from '~/components/ui/MyRare'
import { RareFlag } from '~/graphqls/types'
import styled from 'styled-components'
import { Select } from 'antd'
import { VipIcon } from '~/components/icon/Vip'
import {
  TabsItemProps,
  INDEX_RANK_ITEM_LIST_TYPE,
  RANK_TAB_TYPE,
} from '~/components/pages/rank/hooks'
import { AI_CREATORS_TAB_TYPE } from '~/components/pages/rank/hooks/useAiCreators'

const MyRankSelect = styled(Select)<{
  $dark?: boolean
}>`
  .ant-select-selector {
    width: 84px;
    border: none !important;
    box-shadow: none !important;
    background-color: ${props => props.theme.light2}!important;
    color: ${props => props.theme.dark4}!important;
    .ant-select-selection-item {
      color: ${props => props.theme.dark4}!important;
    }
  }
`

const MySelectDropdown = styled.div`
  width: 74px;
  .ant-select-item {
    padding: 0;
    min-height: 0;
    border-bottom: 1px solid #e6e8ec;
    padding: 16px 0 8px 0;
    margin: 0 16px;
    line-height: 1;
    &:last-child {
      border: none;
    }
    &:hover {
      background-color: #fff;
    }
  }
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: #fff;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: #fff;
  }
`
/** 集中格式化数据 */
const formatRankDetail = (item: any, index: number, parentType: string) => {
  let detail
  if (parentType === RANK_TAB_TYPE.COLLECTIONS) {
    detail = {
      id: `${item.sortId}_${index + 1}`,
      name: item?.artworkSeries?.artist?.name,
      userRoleInfo: item?.artworkSeries?.artist?.userRoleInfo,
      description: item?.artworkSeries?.name,
      likeCount: item?.likeCount || 0,
      image: item?.artworkSeries?.image,
      artworkCount: item?.artworkSeries?.artworkCount || 0,
      collectCount: item?.collectCount || 0,
      link: `/collection/${item?.artworkSeries?.id}`,
      uid: item?.artworkSeries?.artist?.id,
    }
  } else if (parentType === RANK_TAB_TYPE.WORKS) {
    detail = {
      id: `${item?.artwork?.id}_${index + 1}`,
      description: item?.artwork?.name,
      name: item?.artwork?.nArtist?.nickname,
      userRoleInfo: item?.artwork?.nArtist?.userRoleInfo,
      image: item?.artwork?.artworkUrl,
      price: item?.artwork?.buy?.[0]?.price || 0,
      link: `/product/${item?.artwork?.id}`,
      rareFlag: item?.artwork?.rareFlag,
      uid: item?.artwork?.nArtist?.uid,
    }
  } else if (parentType === RANK_TAB_TYPE.CREATORS) {
    detail = {
      id: `${item.uid}_${index + 1}`,
      description: item?.base?.nickname || '',
      userRoleInfo: item?.base?.userRoleInfo,
      likeCount: item?.social?.likesCount || 0,
      image: item?.base?.avatarUrl,
      fansCount: item?.social?.fansCount || 0,
      uid: item?.uid,
      link: `/user/${item?.uid}`,
      artworkCount: item?.artworkStatistics?.artworkCount || 0,
    }
  } else {
    // ai创作
    detail = {
      id: `${item.uid}_${index + 1}`,
      description: item?.base?.nickname || '',
      userRoleInfo: item?.base?.userRoleInfo,
      likeCount: item?.social?.likesCount || 0,
      image: item?.base?.avatarUrl,
      fansCount: item?.social?.fansCount || 0,
      uid: item?.uid,
      link: `/user/${item?.uid}`,
      aiSameStyleCount: item?.artworkStatistics?.aiSameStyleCount || 0,
      aiPictureCount: item?.artworkStatistics?.aiPictureCount || 0,
      squareCount: item?.social?.squareCount || 0,
    }
  }
  return detail
}

const IndexRank: React.FC<INDEX_RANK_ITEM_LIST_TYPE<any>> = ({
  parentType,
  type,
  name,
  data: _data = [],
  timeTabsList,
  onTimeChange = () => {},
}) => {
  const data = useMemo(() => {
    return _data.map((item, index) => formatRankDetail(item, index, parentType))
  }, [_data])
  const router = useRouter()
  return (
    <StyledRankContent>
      <div className="top">
        <div className="title">{name}</div>
        {!!timeTabsList?.length && (
          <MyRankSelect
            onChange={value => {
              onTimeChange?.(value, type, parentType)
            }}
            defaultValue={timeTabsList[0].key}
            dropdownStyle={{
              minWidth: 74,
              width: '74px',
              borderRadius: 8,
              boxShadow: '0px 4px 16px -8px rgba(15, 15, 15, 0.2)',
            }}
            getPopupContainer={triggerNode => triggerNode.parentElement}
            dropdownRender={originNode => (
              <MySelectDropdown>{originNode}</MySelectDropdown>
            )}
          >
            {timeTabsList.map((item: TabsItemProps) => (
              <MyRankSelect.Option value={item.key} key={item.key}>
                {item.name}
              </MyRankSelect.Option>
            ))}
          </MyRankSelect>
        )}
      </div>
      {data.length ? (
        <div className="rank-list">
          {data.map((item, i) => (
            <div
              className="item"
              key={item.id}
              onClick={() => router.push(item.link)}
            >
              <div className="left">
                <img
                  src={`/images/rank/medal_${i + 1}.png`}
                  alt=""
                  width={24}
                  height={24}
                />
                {parentType === RANK_TAB_TYPE.AI_CREATORS ||
                parentType === RANK_TAB_TYPE.CREATORS ? (
                  <div className="creator">
                    <CreatorAvatar
                      image={item.image}
                      size={72}
                      iconClassName="h-[16px] right-[2px] max-w-[24px]"
                      userRole={item?.userRoleInfo}
                      style={{ margin: '0 8px' }}
                    />
                  </div>
                ) : (
                  <MyImage
                    tag="v400"
                    src={item.image}
                    alt=""
                    className="avatar"
                  />
                )}
              </div>
              <div className="right">
                <div className="desc">
                  <div className="title">{item.description}</div>
                  {parentType === RANK_TAB_TYPE.WORKS && (
                    <MyRare
                      className="-mt-0.5 ml-2 flex-shrink-0"
                      rare={item?.rareFlag as RareFlag}
                    />
                  )}
                </div>
                {parentType == RANK_TAB_TYPE.WORKS ||
                parentType == RANK_TAB_TYPE.COLLECTIONS ? (
                  <div
                    className="name"
                    onClick={e => {
                      e.stopPropagation()
                      router.push(`/user/${item.uid}`)
                    }}
                  >
                    {item.name}
                    <VipIcon
                      border={false}
                      userRole={item.userRoleInfo}
                      className="h-[14px] max-w-[21px]"
                    />
                  </div>
                ) : null}

                <div className="works-info">
                  {parentType === RANK_TAB_TYPE.WORKS && item.price > 0 && (
                    <div>¥ {FenToYuan(item.price)}</div>
                  )}
                  {parentType === RANK_TAB_TYPE.COLLECTIONS && (
                    <Fragment>
                      <>
                        <MyIcon icon="archive" className="icon" />
                        {item.artworkCount} 作品
                      </>

                      <div style={{ margin: '0 17px' }}>
                        <MyIcon icon="heart" className="icon" />
                        {item.likeCount}
                      </div>
                      <>
                        <MyIcon icon="star" className="icon" />
                        {item.collectCount}
                      </>
                    </Fragment>
                  )}
                  {parentType === RANK_TAB_TYPE.CREATORS && (
                    <Fragment>
                      {item.fansCount > 0 && (
                        <div style={{ marginRight: 8 }}>
                          <MyIcon icon="user" className="icon" />
                          {item.fansCount}
                        </div>
                      )}
                      {item.artworkCount > 0 && (
                        <div>
                          <MyIcon icon="archive" className="icon" />
                          {item.artworkCount} 作品
                        </div>
                      )}
                    </Fragment>
                  )}
                  {parentType === RANK_TAB_TYPE.AI_CREATORS && (
                    <Fragment>
                      {type === AI_CREATORS_TAB_TYPE.SAME_STYlE &&
                      item?.aiSameStyleCount ? (
                        <div style={{ marginRight: 8 }}>
                          被同款{digitalUnit(item?.aiSameStyleCount || 0)}次
                        </div>
                      ) : null}
                      {type === AI_CREATORS_TAB_TYPE.PICTURE_COUNT &&
                      item?.aiPictureCount ? (
                        <div style={{ marginRight: 8 }}>
                          作画{digitalUnit(item?.aiPictureCount || 0)}次
                        </div>
                      ) : null}
                      {type === AI_CREATORS_TAB_TYPE.FANS_COUNT &&
                      item?.fansCount ? (
                        <div style={{ marginRight: 8 }}>
                          粉丝{digitalUnit(item?.fansCount || 0)}
                        </div>
                      ) : null}

                      {item?.squareCount ? (
                        <div>
                          发布广场
                          {digitalUnit(item?.squareCount || 0)}
                        </div>
                      ) : null}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <MyEmpty />
      )}
    </StyledRankContent>
  )
}
export default React.memo(IndexRank)
